import { render } from "./Villas.vue?vue&type=template&id=87d8d438"
import script from "./Villas.vue?vue&type=script&lang=js"
export * from "./Villas.vue?vue&type=script&lang=js"
script.render = render

export default script